<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div
    v-if="hideContent"
    class="container"
  >
    <h1>
      <span class="accent">
        {{ getTranslation('titleAccent') }}
      </span>
      {{ getTranslation('titleText') }}
    </h1>

    <div class="background">
      <div class="image-404" />
    </div>
    <p class="description">
      {{ getTranslation('description') }}
    </p>

    <IgcButton
      v-if="backPath"
      @click="navigateBack()"
    >
      {{ getTranslation('back') }}
    </IgcButton>
  </div>
</template>

<script lang="ts" setup>
import { computed, defineAsyncComponent } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { useI18n } from '@/shared/helpers/i18n';
import { useWorkflowManager } from '@/shared/helpers/helpers';

const store = useStore();
const IgcButton = defineAsyncComponent(() => import('../IgcButton/IgcButton.vue'));
const { te } = useI18n();
const backPath = computed(() => useWorkflowManager()?.compiler?.getState?.page);
const hideContent = computed(() => !store.getters.isLoggedIn && !store.getters['httpModule/isLoading']);

const defaultTranslation = {
  titleAccent: 'Whoops!',
  titleText: "Page doesn't exist",
  description: 'We usually have SOME findings,\nbut this is a complete mystery',
  back: 'Take me back',
};

function getTranslation(key: string) {
  return te(`pageNotFound.${key}`) || defaultTranslation[key];
}

function navigateBack() {
  useRouter().push({ path: backPath.value.fullPath });
}

</script>

<style lang="less" scoped>
@import "../../shared/styles/style.less";

h1 {
  font-size:   26px;
  line-height: 38px;
  font-weight: 600;
  color:       var(--neutral--hugo);

  .accent {
    font-size: 28px;
    color: var(--primary--mario);
  }
}

.description {
  font-size:     14px;
  color:         var(--neutral--richard);
  font-weight:   bold;
  margin-bottom: 35px;
  white-space:   pre-wrap;
}
.container{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin:       0 auto;
  max-width:       800px;
}

.background {
  display:         flex;
  background:      url("/ui-assets/access/images/404-background.svg");
  background-size: initial;
  max-width:       1100px;
  width:           100%;
  height:          375px;
  margin:          60px auto;

  .image-404 {
    margin:     0 auto;
    width:      70%;
    max-height:          387px;
    background-image:      url("/ui-assets/access/images/404-image.svg");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
  }
}

@media screen and (min-width: @Desktop-Breakpoint) {
  h1 {
    font-size:   30px;
    line-height: 46px;
    font-weight: 600;

    .accent {
      font-size: 32px;
    }
  }

  .description {
    white-space: normal;
  }
}

</style>
